export const HeaderTools: {
  label: string;
  tools: {
    title: string;
    describe: string;
    url?: string;
    icon: string;
    isDialog?: boolean;
    dialogType?: string;
  }[];
}[] = [
  {
    label: '批量工具',
    tools: [
      {
        title: '批量创建计划',
        describe: '聚光创编链路升级版，可快速创建百条计划',
        url: '/create-campaign-v2',
        icon: 'assets/images/tools_create_campaign.png',
      },
      {
        title: '批量创建单元',
        describe: '叉乘逻辑，可快速创建百条单元',
        url: '/create-unit',
        icon: 'assets/images/tools_create_unit.png',
      },
      {
        title: '定制化创建计划',
        describe: '自定义搭建，可快速创建百条计划',
        url: '/create-campaign-pro',
        icon: 'assets/images/tools_create_campaign.png',
      },
      {
        title: '批量添加创意',
        describe: '批量添加创意，可快速创建百条创意',
        url: '/promotion/unify?index=5',
        icon: 'assets/images/tools_create_campaign.png',
      },
    ],
  },
  {
    label: '表格工具',
    tools: [
      {
        title: '批量上传计划',
        describe: '表格导入计划信息，高效完成计划搭建',
        icon: 'assets/images/tools_upload_excel.png',
        isDialog: true,
        dialogType: 'campaignUpload',
      },
      {
        title: '批量修改计划预算',
        describe: '表格批量修改计划预算，统一调整更快捷',
        icon: 'assets/images/tools_upload_excel.png',
        isDialog: true,
        dialogType: 'campaignBudget',
      },
      {
        title: '批量修改计划名称',
        describe: '表格批量修改计划名称，统一调整更快捷',
        icon: 'assets/images/tools_upload_excel.png',
        isDialog: true,
        dialogType: 'campaignName',
      },
      {
        title: '批量修改单元出价',
        describe: '表格批量修改单元出价，统一调整更快捷',
        icon: 'assets/images/tools_upload_excel.png',
        isDialog: true,
        dialogType: 'unitBid',
      },
      {
        title: '批量修改高级定向',
        describe: '表格批量修改高级定向，统一调整更快捷',
        icon: 'assets/images/tools_upload_excel.png',
        isDialog: true,
        dialogType: 'unitTarget',
      },
      {
        title: '批量添加创意',
        describe: '表格导入多平台创意，高效完成发布',
        icon: 'assets/images/tools_upload_excel.png',
        isDialog: true,
        dialogType: 'creativeUpload',
      },
      {
        title: '批量编辑创意',
        describe: '表格批量修改创意内容，统一调整更快捷',
        icon: 'assets/images/tools_upload_excel.png',
        isDialog: true,
        dialogType: 'creativeEdit',
      },
      {
        title: '批量上传监测链接',
        describe: '表格导入跟踪链接，快速配置监测',
        icon: 'assets/images/tools_upload_excel.png',
        isDialog: true,
        dialogType: 'monitor',
      },
      {
        title: '批量上传关键词',
        describe: '表格批量添加账户关键词，省时省力',
        icon: 'assets/images/tools_upload_excel.png',
        isDialog: true,
        dialogType: 'keyword',
      },
      {
        title: '批量修改关键词出价',
        describe: '表格批量修改关键词出价，统一调整更快捷',
        icon: 'assets/images/tools_upload_excel.png',
        isDialog: true,
        dialogType: 'keywordBid',
      },
    ],
  },
  {
    label: '其他工具',
    tools: [
      {
        title: '任务管理',
        describe: '实时监控批量创建任务执行状态',
        url: '/task-list',
        icon: 'assets/images/tools_task_list.png',
      },
      // {
      //   title: '商品关键词关联',
      //   describe: '商品关键词关联，商品关键词自由掌控',
      //   url: '/tools/marking',
      //   icon: 'assets/images/tools_marking.png',
      // },
      {
        title: '操作记录',
        describe: '操作记录，每一步操作都有留痕',
        url: '/tools/operation-record',
        icon: 'assets/images/tools_operation_record.png',
      },
      {
        title: '笔记ID解析',
        describe: '解析笔记ID，高效提取省时省力',
        url: '/tools/note-id-parsing',
        icon: 'assets/images/tools_note_id_parsing.png',
      },
      {
        title: '笔记预审',
        describe: '自定义笔记审核，笔记预审自由掌控',
        url: '/tools/note-audit',
        icon: 'assets/images/tools_note_audit.png',
      },
      // {
      //   title: '定向包',
      //   describe: '定向包管理，人群管理自由掌控',
      //   url: '/tools/target-package',
      //
      // }
    ],
  },
];
